import { AutocompleteHOC } from 'hocs'
import Suggest from 'components/Osearch/Suggest'

function SuggestContainer(props) {
  const { suggestions, value,handleSelect, handleClear, isFetching } = props

  const inputProps = {
    placeholder: 'Search Issue...',
    value,
    onChange: props.onChange
  }

  const autosuggestProps = {
    inputProps,
    onSuggestionSelected: handleSelect,
    onSuggestionsFetchRequested: () => {},
    onSuggestionsClearRequested: props.onSuggestionsClearRequested,
    suggestions
  }
  const suggestProps = {
    autosuggestProps,
    clearHandler: handleClear,
    isFetching
  }

  return <Suggest {...suggestProps} />
}

export default AutocompleteHOC(SuggestContainer)
